import { render, staticRenderFns } from "./LoginFormUpdated.vue?vue&type=template&id=1304d9a1&scoped=true"
import script from "./LoginFormUpdated.vue?vue&type=script&lang=js"
export * from "./LoginFormUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304d9a1",
  null
  
)

export default component.exports